import { CheckCircleOutlined } from "@ant-design/icons";
import { Button, Flex, Space, Typography, theme } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../providers/NotificationProvider";
import { logout } from "../lib/http";
import { AuthCard } from "../components/AuthCard";

function Logout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notifier = useNotifier();
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        // Clear session from localStorage, keep username/db for convenience
        localStorage.removeItem("session");
        setLoading(false);
      } catch (err) {
        console.error("Logout failed:", err);
        setError(true);
        setLoading(false);
        notifier.error({
          message: t("auth.logout.error"),
          description: t("auth.logout.errorDescription"),
        });
      }
    };

    performLogout();
  }, [notifier, t]);

  // Auto-redirect countdown
  useEffect(() => {
    if (!loading && !error && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }

    if (countdown === 0 && !error) {
      navigate("/");
    }
  }, [countdown, loading, error, navigate]);

  return (
    <AuthCard
      title={t("auth.logout.title")}
      subtitle={t("auth.logout.subtitle")}
    >
      {loading ? (
        <Flex vertical gap={16} align="center">
          <Space direction="vertical" size={0} align="center">
            <Typography.Text>{t("auth.logout.processing")}</Typography.Text>
          </Space>
        </Flex>
      ) : error ? (
        <Flex vertical gap={16} align="center">
          <Space direction="vertical" size={0} align="center">
            <Typography.Text type="danger">
              {t("auth.logout.error")}
            </Typography.Text>
          </Space>
          <Button type="primary" block onClick={() => navigate("/")} size="large">
            {t("auth.logout.backToLogin")}
          </Button>
        </Flex>
      ) : (
        <Flex vertical gap={16} align="center">
          <CheckCircleOutlined
            style={{ fontSize: 48, color: token.colorSuccess }}
          />
          <Space direction="vertical" size={4} align="center">
            <Typography.Text strong>
              {t("auth.logout.completed")}
            </Typography.Text>
            <Typography.Text type="secondary">
              {t("auth.logout.redirecting", {
                seconds: countdown,
              })}
            </Typography.Text>
          </Space>
          <Button
            type="primary"
            block
            onClick={() => navigate("/")}
            size="large"
            style={{ marginTop: 8 }}
          >
            {t("auth.logout.backToLogin")}
          </Button>
        </Flex>
      )}
    </AuthCard>
  );
}

export default Logout;
